import { BEACON_MODES_INVERSE, BEACON_MODES_ALTERNATIVE } from './constants.js';
/**
 * Gets the inverse beacon mode of the given mode.
 * @param mode - The beacon mode.
 * @returns The inverse beacon mode.
 */
export function getInverseBeaconMode(mode) {
    return BEACON_MODES_INVERSE[mode];
}
/**
 * Gets the alternate beacon mode of the given mode, meaning the other mode within the same category of light vs dark.
 * For example, the alternate of 'light' is 'lighter' and vice versa.
 * @param mode - The beacon mode.
 * @returns The alternate beacon mode.
 */
export function getAlternateBeaconMode(mode) {
    return BEACON_MODES_ALTERNATIVE[mode];
}
//# sourceMappingURL=modes.js.map